import React, { Component } from 'react';
import moment from 'moment';
import queryString from 'query-string';

import { USER_ROLE_ADMIN } from 'common/userRoles';

import {
  SR_HITLIST_STATUS_CREATED,
  SR_HITLIST_STATUS_STARTED,
  SR_HITLIST_STATUS_COMPLETED,
  SR_HITLIST_TASK_CALL_OUTCOME_NOT_ANSWERED,
} from 'common/hitlistTaskConstants';

import { SCREEN_ID_HITLIST_TASKS } from 'client/constants/screenIds';

import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedRoles from 'client/helpers/allowedRoles';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import HitlistTaskList from 'client/components/HitlistTaskList/HitlistTaskList';

@withTransitionHook
@allowedRoles({
  roles: [USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_HITLIST_TASKS)
@withScrollToTop
@branch({
  currentUser: ['currentUser'],
})
class HitlistPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Admin Hitlist | Sunroom Rentals',
    section: 'Hitlist',
  });

  constructor(props) {
    super(props);

    this.state = {
      toCompletedAt: moment().subtract(2, 'hours').toISOString(),
    };
  }

  render() {
    const { currentUser, dispatch, location } = this.props;

    const { toCompletedAt } = this.state;

    const locationQuery = queryString.parse(location.search || '');
    const tourListingId = parseInt(locationQuery.tourListingId, 10) || null;

    return (
      <div>
        <SrBox width="1150px" maxWidth="1150px" margin="48px auto">
          <SrFlex justify="center" marginBottom="40px">
            <SrText font="greycliff" size="40" weight="800">
              Call Hitlist
            </SrText>
          </SrFlex>

          <HitlistTaskList
            title="Call Now"
            highPriority
            status={[SR_HITLIST_STATUS_CREATED, SR_HITLIST_STATUS_STARTED]}
            tourListingId={tourListingId}
            currentUser={currentUser}
            dispatch={dispatch}
          />

          <SrBox margin="40px 0 200px">
            <HitlistTaskList
              title="Did Not Answer, Call Again"
              highPriority
              status={[SR_HITLIST_STATUS_COMPLETED]}
              callOutcome={SR_HITLIST_TASK_CALL_OUTCOME_NOT_ANSWERED}
              toCompletedAt={toCompletedAt}
              tourListingId={tourListingId}
              currentUser={currentUser}
              dispatch={dispatch}
            />
          </SrBox>
        </SrBox>
      </div>
    );
  }
}

HitlistPage.displayName = 'HitlistPage';

export default HitlistPage;
